<template>
  <div>
    <ul v-if="impact.signals && impact.signals.length > 0" class="mb-3 mt-2">
      <li v-for="(signal, index) in impact.signals" :key="index">
        {{ signal }}
      </li>
    </ul>
    <CdrOverviewDelta
      :delta="impact.overview_delta"
      :empty-display="impact.overview_delta_empty_display"
    />
  </div>
</template>

<script>
import CdrOverviewDelta from "./CdrOverviewDelta.vue";

export default {
  components: { CdrOverviewDelta },
  props: {
    impact: { type: Object, required: true },
  },
};
</script>
